import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
let trustedSwiperWr = document.querySelectorAll('.trusted-swiper-wr');
console.log(trustedSwiperWr);

trustedSwiperWr?.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    // let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 44,
      slidesPerView: 'auto',
      loop: slidesCount >= 3,
      centeredSlides: false,
      initialSlide: 8,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        1024: {
          spaceBetween: 60,
          slidesPerView: 'auto',
        },
      },
      autoplay: {
        delay: window.innerWidth > 1024 ? '3000' : '4000',
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });

    swiperObserver(swiper);
  }
});